import { getInputValues } from "./_input.js";
import { calculateHousePrice, calculateLandPrice } from "./_api.js";
import { displayError } from "./_display.js";

// 前回の値を保存
let lastRequestData = null;

/**
 * オブジェクトの深い比較（内部関数）
 * @param {Object} obj1 比較対象1
 * @param {Object} obj2 比較対象2
 * @returns {boolean}
 */
const isEqual = (obj1, obj2) => {
    if (obj1 === null || obj2 === null) {
        return obj1 === obj2;
    }
    return JSON.stringify(obj1) === JSON.stringify(obj2);
};

/**
 * 価格計算を実行
 * @param {string} type 物件種別
 * @param {Object} context コンテキストオブジェクト
 * @param {Object} context.inputs 入力要素オブジェクト
 * @param {HTMLElement} context.resultElement 結果表示要素
 */
export const executeCalculation = async (type, context) => {
    const inputValues = getInputValues(type, context.inputs);

    if (!inputValues) {
        displayError(context.resultElement);
        lastRequestData = null;
        return;
    }

    // 前回の値と同じ場合はリクエストを送らない
    if (isEqual(lastRequestData, inputValues)) {
        return;
    }

    // 前回の値を更新
    lastRequestData = { ...inputValues };

    if (type === "house") {
        await calculateHousePrice(inputValues, context.resultElement);
    } else if (type === "land") {
        await calculateLandPrice(inputValues, context.resultElement);
    }
};
